import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { ShareRecordingForm } from "./share-recording-form";

type ShareRecordingModalProps = {
  recordingId: string;
};

export function ShareRecordingModal(props: ShareRecordingModalProps) {
  return (
    <>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share a link to this replay</DialogTitle>
        </DialogHeader>
        <ShareRecordingForm recordingId={props.recordingId} />
      </DialogContent>
    </>
  );
}
